import React, { useState } from 'react';
import { ShoppingCart, RefreshCcw , BookUser, MapPin, CreditCard, KeyRound, Gift, LogOut, CalendarSync } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { performLogout } from '../../store/thunk/authThunk';

const ContentUserMenu = [
    {
        id: 1,
        title: 'My Orders',
        path: '/orders',
        description: 'Keep track of your orders.',
        icon: <ShoppingCart className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 2,
        title: 'My Subscriptions',
        path: '/subscriptions',
        description: 'Manage your subscriptions',
        icon: <CalendarSync  className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 3,
        title: 'Billing Address',
        path: '/billing-address',
        description: 'Update your billing address.',
        icon: <BookUser className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 4,
        title: 'Delivery Method',
        path: '/delivery-method',
        description: 'Update your delivery method.',
        icon: <MapPin className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 5,
        title: 'Payment Details',
        path: '/payment-details',
        description: 'Update card and PayPal.',
        icon: <CreditCard className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 6,
        title: 'Password Settings',
        path: '/password-settings',
        description: 'Change your password.',
        icon: <KeyRound className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 7,
        title: 'Rewards',
        path: '/rewards',
        description: 'Rewards from your orders.',
        icon: <Gift className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
    {
        id: 8,
        title: 'Sign out',
        path: '/signout',
        description: 'Halalfull Sign out.',
        icon: <LogOut className='lg:w-7 lg:h-7 md:w-6 md:h-6' />,
    },
];

const SideTabMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleItemClick = (item) => {
        if (item.path === '/signout') {
            console.log('Logging out...');
            dispatch(performLogout()).then(() => {
                // Redirect to signin page after logout
                navigate('/signin', { replace: true });
            });
            return;
        }

        if (item.path) {
            navigate(item.path);
        }
    };

    return (
        <div className='w-full bg-[#f9f9f9] border border-neutral-200 rounded-lg shadow-[0_3px_10px_rgb(0,0,0,0.2)]'>
            <div className='space-y-1 p-2'>
                {ContentUserMenu.map((item) => {
                    const isActive = location.pathname.startsWith(item.path || '');

                    return (
                        <div
                            key={item.id}
                            className={`flex items-center px-2 md:px-0 lg:px-2 py-3 cursor-pointer transition-all duration-200 hover:bg-gray-50 border-b border-gray-200 last:border-b-0 ${
                                isActive ? '' : ''
                            }`}
                            onClick={() => handleItemClick(item)}
                        >
                            <div className='flex items-center justify-center w-10 h-10 rounded-lg md:mr-0 lg:mr-4'>
                                <div className='text-primary-text'>{item.icon}</div>
                            </div>

                            <div className='flex-1 min-w-0'>
                                <h3
                                    className={`md:text-md lg:text-base font-medium tracking-[0.7px] ${
                                        isActive ? 'text-primary-text' : ''
                                    }`}
                                >
                                    {item.title}
                                </h3>
                                <p className='text-xs text-gray-400 leading-relaxed tracking-[0.7px]'>
                                    {item.description}
                                </p>
                            </div>

                          
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default SideTabMenu;
